module.exports = __webpack_public_path__ + "static/media/storytelling_made_easy_2021.5099067d.png";